export const formatSeconds = (seconds: number): string => {
  const mins = Math.floor(seconds / 60)
  const mod = Math.floor(seconds) % 60
  return `${mins < 10 ? '0' : ''}${mins}:${mod < 10 ? '0' : ''}${mod}`
}
